module.exports = "/next-static/_next/static/images/oneStreamMultipleDestinations-30630b7a009d6ddaae97821f26a3c705.png";